/**
 * Wrapper page — Microsoft Integrations settings inside dashboard layout
 */
import React from 'react';
import DashLayout from '../../../layouts/dashboard/dashLayout';
import { useAppSelector } from '../../../stores';
import MicrosoftIntegrationsSettings from './MicrosoftIntegrationsSettings';

const MicrosoftIntegrationsView: React.FC = () => {
    const users = useAppSelector((state) => state.auth);
    const accessToken = users.access_token || '';

    return (
        <DashLayout>
            {accessToken ? (
                <MicrosoftIntegrationsSettings accessToken={accessToken} />
            ) : (
                <div className="p-4">Please sign in to manage Microsoft integrations.</div>
            )}
        </DashLayout>
    );
};

export default MicrosoftIntegrationsView;
